import React, { useEffect } from "react";
import { RootRouteProps } from "routers/types/stack";
import { useRoute } from "@react-navigation/native";

import { View, ScrollView, Linking } from "react-native";
import {
  Input,
  Picker,
  Button,
  TextArea,
  InputLabel,
  DatePicker,
} from "components";
import { getFormatedDate } from "react-native-modern-datepicker";
import { useForm, Controller } from "react-hook-form";

import { colors, patterns, sizes, strings } from "assets/constants";
import css from "styles";

import { useCustomerReligion, useEditCustomer } from "clients/apis";
import Phones from "./Phones";
import Emails from "./Emails";
import Socials from "./Socials";
import { getPostData } from "../helper";
import { mq, sn } from "utils";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { useChmod } from "hooks";
import { _goToBack } from "routers/helper";

export default function SupplementInfo() {
  const { chmod } = useChmod();

  const { role, id: userId } = useRecoilValue(authAtom);

  const { data } = useRoute<RootRouteProps<"customerTabs">>().params;
  const { data: customerReligion } = useCustomerReligion();

  // const hasEditPermission = role === "cto" || userId === data?.admin_id;
  // const hasEditPermission = chmod("customer", "PUT");
  const hasEditPermission =
    chmod("customer", "PUT") &&
    (role === strings.ceo || data?.admin_id === userId);

  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors: inputErrors },
  } = useForm<CustomerFormDataT>({
    // defaultValues: {
    //   nationalCode: "",
    //   religion: null,
    //   phones: null,
    //   socials: null,
    //   emails: null,
    //   website: "",
    //   birthday: "",
    //   familiarityDate: "",
    //   attendTimes: "",
    //   descriptions: "",
    // },
  });

  useEffect(() => {
    if (data) {
      setValue("nationalCode", data?.national_code);
      setValue("religion", data?.religion);
      setValue("phones", data?.phone);
      setValue("socials", data?.social);
      setValue("emails", data?.email);
      setValue("website", data?.website);
      setValue("birthday", data?.birthday);
      setValue("familiarityDate", data?.friendship_at);
      setValue("attendTimes", data?.facing_meeting);
      setValue("descriptions", data?.description);
    }
  }, [data, setValue]);

  const editCustomerMut = useEditCustomer();
  const _onEdit = () =>
    editCustomerMut.mutate(
      {
        id: data?.id,
        data: { ...getPostData(getValues(), data?.id), section: "extra" },
      },
      { onSuccess: _goToBack }
    );

  return (
    <>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={css.responsiveInputsListContainer}
      >
        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.national_code} />
          <Controller
            name="nationalCode"
            rules={{
              pattern: {
                value: patterns.number,
                message: strings.invalid_national_code,
              },
            }}
            control={control}
            render={({ field: { value, onChange } }) => (
              <Input
                editable={hasEditPermission}
                value={value}
                onChangeText={onChange}
                icon={{ name: "credit-card" }}
                placeholder={strings.insert_customer_national_code}
                keyboardType="number-pad"
                maxLength={10}
                error={inputErrors.nationalCode?.message}
              />
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.religion} />
          <Controller
            name="religion"
            control={control}
            render={({ field: { value, onChange } }) => {
              return (
                <Picker
                  disabled={!hasEditPermission}
                  onSelect={onChange}
                  value={value?.title ? value?.title : undefined}
                  data={customerReligion?.data}
                  icon={{ name: "airplay" }}
                  placeholder={strings.pick_customer_religion}
                />
              );
            }}
          />
        </View>
        <View style={css.fitWidth}>
          <InputLabel label={strings.phones} />
          <Controller
            name="phones"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Phones
                disabled={!hasEditPermission}
                onChange={onChange}
                phones={value}
              />
            )}
          />
        </View>

        <View style={css.fitWidth}>
          <InputLabel label={strings.socials} />
          <Controller
            name="socials"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Socials
                disabled={!hasEditPermission}
                socials={value}
                onChange={onChange}
              />
            )}
          />
        </View>

        <View style={css.fitWidth}>
          <InputLabel label={strings.emails} />
          <Controller
            name="emails"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Emails
                disabled={!hasEditPermission}
                emails={value}
                onChange={onChange}
              />
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.website} />
          <Controller
            name="website"
            control={control}
            render={({ field: { value, onChange } }) => (
              <View>
                <Input
                  editable={hasEditPermission}
                  value={value}
                  onChangeText={onChange}
                  icon={{ name: "globe" }}
                  placeholder={strings.insert_customer_website}
                  keyboardType="url"
                />
                {getValues()?.website !== "" &&
                  getValues()?.website !== null && (
                    <Button
                      onPress={() =>
                        Linking.openURL(
                          String(getValues()?.website)?.replace(
                            "www.",
                            "http://"
                          )
                        )
                      }
                      icon={{ name: "link", size: 23 }}
                      width={mq(45)}
                      height={mq(42)}
                      absolute
                      left={3}
                      top={4}
                    />
                  )}
              </View>
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.birthday} />
          <Controller
            name="birthday"
            control={control}
            render={({ field: { value, onChange } }) => (
              <View>
                <DatePicker
                  disabled={!hasEditPermission}
                  maximumDate={getFormatedDate(new Date(), "jYYYY/jMM/jDD h:m")}
                  value={value}
                  onSelect={onChange}
                  placeholder={strings.pick_customer_birthday}
                />

                {getValues().birthday !== null &&
                  getValues().birthday !== "" && (
                    <Button
                      onPress={() => setValue("birthday", null)}
                      icon={{
                        name: "close",
                        type: "antDesign",
                        size: 18,
                        color: colors.textColorGray,
                      }}
                      bgColor={colors.transparent}
                      width={mq(45)}
                      height={mq(42)}
                      absolute
                      left={30}
                    />
                  )}
              </View>
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.familiarity_date} />
          <Controller
            name="familiarityDate"
            control={control}
            render={({ field: { value, onChange } }) => (
              <View>
                <DatePicker
                  disabled={!hasEditPermission}
                  value={value}
                  onSelect={onChange}
                  placeholder={strings.pick_familiarity_date}
                />

                {getValues().familiarityDate !== null &&
                  getValues().familiarityDate !== "" && (
                    <Button
                      onPress={() => setValue("familiarityDate", null)}
                      icon={{
                        name: "close",
                        type: "antDesign",
                        size: 18,
                        color: colors.textColorGray,
                      }}
                      bgColor={colors.transparent}
                      width={mq(45)}
                      height={mq(42)}
                      absolute
                      left={30}
                    />
                  )}
              </View>
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.attend_time} />
          <Controller
            name="attendTimes"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Input
                editable={hasEditPermission}
                value={value}
                onChangeText={onChange}
                icon={{ name: "calendar" }}
                placeholder={strings.insert_attend_time}
              />
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.descriptions} />
          <Controller
            name="descriptions"
            control={control}
            render={({ field: { value, onChange } }) => (
              <TextArea
                editable={hasEditPermission}
                value={value}
                onChangeText={onChange}
                icon={{ name: "align-right" }}
                placeholder={strings.insert_customer_descriptions}
              />
            )}
          />
        </View>
      </ScrollView>

      {hasEditPermission && (
        <View
          style={{
            ...css.paddingH,
            marginVertical: sizes.space / 2,
            maxWidth: sn("100%", "100%", 300, 300),
          }}
        >
          <Button
            loading={editCustomerMut.isLoading}
            style={css.selfCenter}
            title={{ value: strings.submit_info }}
            onPress={handleSubmit(_onEdit)}
          />
        </View>
      )}
    </>
  );
}
